import initUserMenuLoginItem from './Login/UserMenuLoginItem';
import initLoginStateElement from './Login/LoginStateElement';
import initLogout from './Login/logout';
import initSignupButton from './Signup/signup';
import initUpdateUserForm from './UpdateUser/updateuser';
import initChangePasswordForm from './ChangePassword/changepassword';
import initDeleteProfileForm from './DeleteProfile/deleteprofile';
import initResetPasswordForm from './ResetPassword/resetpassword';
import initVerifyEmailForm from './VerifyEmail/verifyemail';
import initEmailAction from './EmailAction/email-action';
import initUserStore from './Store/userstore';
import initUserAffiliationStore from './Store/useraffiliationstore';
import { initAdvertApplicationMessagesIsland } from './AdvertApplicationMessages';
import { initSearchAgentsIsland } from './SearchAgents';

export default function () {
  initUserMenuLoginItem();
  initLoginStateElement();
  initLogout();
  initSignupButton();
  initUpdateUserForm();
  initChangePasswordForm();
  initDeleteProfileForm();
  initResetPasswordForm();
  initVerifyEmailForm();
  initEmailAction();
  initAdvertApplicationMessagesIsland();
  initSearchAgentsIsland();
  initUserStore();
  initUserAffiliationStore();
}